import { Component, OnInit, ViewChild } from '@angular/core';
import { IInsurerContactDetails, IInsurersDetails, SharedConfig, SharedDialogService } from '@takectrl-multiapp/svcs-share-config';
import { Platform, PopoverController } from '@ionic/angular';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
import { BUSNCommunicationService } from 'libs/svcs-core-business/src/lib/services/busn-communication.service';
import { CommunicationService } from '@takectrl-multiapp/svcs-core';
import { APIMetaService } from '@takectrl-multiapp/svcs-ctrl-api';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'chat-button',
  standalone: false,
  templateUrl: './chat-button.component.html',
  styleUrls: ['./chat-button.component.scss'],
})
export class ChatButtonComponent implements OnInit {
  @ViewChild('popover') popover;
  @ViewChild('popover') popoverIntercomWhatsapp;
  href_string: string =
    'mailto:?to=MIDigitalSupport@momentum.co.za&subject=Momentum Insure Online Quoting tool - Technical support query';
  isOpen = false;
  constructor(
    public busnThirdPartyService: BUSNThirdPartyService,
    public sharedConfig: SharedConfig,
    public popoverCtrl: PopoverController,
    public busnCommunicationService: BUSNCommunicationService,
    private platform: Platform, 
    private communicationService: CommunicationService, 
    public apiMetaService: APIMetaService,
    public sharedDialogService: SharedDialogService
  ) {}

  ngOnInit(): void {}

  async presentPopover(e: Event) {
    SharedConfig.showCustomLoader = true;
    if (this.sharedConfig.userPermissions?.phone_broker && this.sharedConfig.appClientDetail.insurer_contact_details && this.sharedConfig.appClientDetail.insurer_contact_details.length > 0) {
      SharedConfig.showCustomLoader = false;
      this.popover.event = e;
      this.isOpen = true;
      
    } else {
      let results = (await firstValueFrom(await this.apiMetaService.getActiveInsurerDetails())).results
      this.sharedConfig.appClientDetail.insurer_contact_details = results;
      SharedConfig.showCustomLoader = false;
      this.popover.event = e;
      this.isOpen = true;
    }
  }

  callBroker() {
    this.isOpen = false;
    this.busnCommunicationService.callBroker();
  }

  openIntercom() {
    this.busnThirdPartyService.intercomDisplayLauncher();
    this.isOpen = false;
    const intervalId = setInterval(() => {
      SharedConfig.intercomBadgeCount = document.querySelector('[data-testid="active-notifications"]').innerHTML
        clearInterval(intervalId);
    }, 1000);
  }

  openWhatsApp() { 
    const phoneNumberWithCountryCode = "27" + this.sharedConfig.user.broker.whatsapp_number.slice(1);
    const url = `https://wa.me/${phoneNumberWithCountryCode}`; window.open(url, '_blank'); 
    this.isOpen = false;
  }

  callInsurer(insurer: IInsurersDetails) {
    this.isOpen = false;
    SharedConfig.showCustomLoader = true;
    let intervalId = setInterval(() => {
        if (this.platform.is('mobileweb')) {
          window.open('tel:' + insurer.contact_number, '_blank')
        } else if (this.platform.is('desktop')) {
          this.sharedDialogService.showPopupDialog({
            header: insurer.description + "'s number:",
            subHeader: insurer.contact_number,
            buttonOneText: 'OK',
            buttonOneCallback: this.sharedDialogService.hidePopupDialog,
          });
        } else {
          this.communicationService.makePhoneCall(insurer.contact_number);
        }
        SharedConfig.showCustomLoader = false;
        clearInterval(intervalId);
    }, 500);
  }
}
